module.exports = __webpack_public_path__ + "img/17.bfb3dd8e.png";